module.exports = __webpack_public_path__ + "static/icons/icon-sort-by-71dc27f16e996106453f423501e56af4.svg";